import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Content = styled(motion.div)`
  grid-area: 1 / 1;
`;

export const Link = styled.a`
  color: inherit;

  &:hover,
  &:focus-visible {
    color: var(--color-neutral-800);
  }

  &:active {
    color: var(--color-black);
  }
`;
